import { Box, Typography } from '@mui/material';
import ActivityLogList from '../components/admin/activity-log-list';

const ActivityLogPage = () => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
          gap: 2,
        }}
      >
        <Typography variant='h5'>Activity log</Typography>
      </Box>
      <ActivityLogList />
    </>
  );
};

export default ActivityLogPage;
